<template>
    <form method="POST" @submit.prevent="onSubmit">
        <div class="max-w-4xl">
            <label class="block text-gray-700" for="name">Name</label>
            <input
                type="text"
                name="name"
                id="name"
                class="block w-full border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1"
                v-model="user.name"
            />
            <div v-if="errors.name" class="invalid-feedback">
                {{ errors.name.join("\r\n") }}
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700" for="email">Email</label>
            <input
                type="text"
                name="email"
                id="email"
                class="block w-full border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1"
                v-model="user.email"
            />
            <div v-if="errors.email" class="invalid-feedback">
                {{ errors.email.join("\r\n") }}
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700" for="password">Password</label>
            <input
                type="password"
                name="password"
                id="password"
                class="block w-full border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1"
                v-model="user.password"
            />
            <div v-if="errors.password" class="invalid-feedback">
                {{ errors.password.join("\r\n") }}
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700" for="roles">Roles</label>
            <select2
                :options="roles"
                key="roles"
                :multiple="true"
                id="roles"
                select-label="name"
                track-by-option="name"
                name="roles"
                ref="roles"
                @sync="userRolesChanged"
                class="mt-1"
            />
            <div v-if="errors.roles" class="invalid-feedback">
                {{ errors.roles.join("\r\n") }}
            </div>
        </div>

        <div v-if="defaultRights.length" class="mt-4 max-w-4xl">
            <span class="block text-gray-700 mb-2">Default Rights</span>
            <div class="block">
                <badge
                    v-for="(defaultRight, index) in defaultRights"
                    :key="index"
                    :value="defaultRight"
                    type="success"
                ></badge>
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700" for="rights">Extra Rights</label>
            <select2
                :multiple="true"
                id="rights"
                select-label="name"
                track-by-option="name"
                name="rights"
                ref="rights"
                :manual-options="availableRights"
                @sync="userRightsChanged"
                class="mt-1"
            />
            <div v-if="errors.rights" class="invalid-feedback">
                {{ errors.rights.join("\r\n") }}
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700" for="roles"
                >Selected Cluster</label
            >
            <select2
                :options="clusters"
                key="selected_cluster_id"
                :multiple="false"
                id="selected_cluster_id"
                select-label="name"
                track-by-option="id"
                name="selected_cluster_id"
                ref="selected_cluster_id"
                :value="user.selected_cluster_id"
                @sync="selectedClusterChanged"
                class="mt-1"
            />
            <div v-if="errors.selected_cluster_id" class="invalid-feedback">
                {{ errors.selected_cluster_id.join("\r\n") }}
            </div>
        </div>

        <div class="mt-6 max-w-4xl">
            <button
                type="submit"
                class="rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-3 mr-4"
            >
                <span>{{ editUser ? "Update" : "Create" }}</span>
            </button>
        </div>
    </form>
</template>

<script>
export default {
    name: "UserForm",
    props: {
        routeIndex: {
            type: String,
            required: true,
        },
        routeStore: {
            type: String,
            required: true,
        },
        editUser: {
            type: Object,
            required: false,
        },
        password: {
            type: String,
            required: false,
        },
        roles: {
            type: Array,
            required: true,
        },
        rights: {
            type: Array,
            required: true,
        },
        clusters: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            user: {
                name: "",
                email: "",
                password: "",
                roles: [],
                rights: [],
                selected_cluster_id: "",
            },
            errors: [],
            allRoles: [],
            allRights: [],
            defaultRights: [],
            availableRights: [],
        };
    },
    mounted() {
        const user = this.editUser ? this.editUser : this.user;
        if (this.editUser) {
            user.password = this.password;
        }
        this.user = user;
        if (this.editUser) {
            this.user.password = "";
            this.$refs.roles.selected = this.user.roles;
            this.$refs.rights.selected = this.user.rights;
            this.$refs.selected_cluster_id.selected = this.user.selectedCluster;
        }
        this.allRoles = this.roles;
        this.allRights = this.rights;
        this.availableRights = this.rights;
        this.updateDefaultRights(this.user.roles);
    },
    methods: {
        userRolesChanged(value, field, attributes, ref, index) {
            if (value) {
                this.user.roles = value;
            }
            this.updateDefaultRights(value);
        },
        userRightsChanged(value, field, attributes, ref, index) {
            if (value) {
                this.user.rights = value;
            }
        },
        selectedClusterChanged(value) {
            if (value) {
                this.user.selected_cluster_id = value;
            }
        },
        onSubmit() {
            if (this.editUser) {
                if (this.user.roles.length) {
                    if (typeof this.user.roles[0] == "object") {
                        this.user.roles = this.user.roles.map(
                            (role) => role.name
                        );
                    }
                }
                if (this.user.rights.length) {
                    if (typeof this.user.rights[0] == "object") {
                        this.user.rights = this.user.rights.map(
                            (right) => right.name
                        );
                    }
                }
            }
            axios
                .post(this.routeStore, {
                    ...this.user,
                })
                .then((response) => {
                    if (response.data && response.data.success) {
                        window.location = this.routeIndex;
                    }
                })
                .catch((error) => {
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.errors
                    ) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        updateDefaultRights(value) {
            // if user roles is empty, empty default rights
            if (!value.length) {
                this.defaultRights = [];
                return;
            }
            const defaultRights = [];
            this.user.roles.forEach((role) => {
                const roleName = typeof role == "object" ? role.name : role;
                const roleFound = this.allRoles.filter(
                    (r) => r.name == roleName
                );
                const rights = roleFound[0].rights.map((right) => right.name);
                defaultRights.push(...rights);
                this.defaultRights = [...new Set(defaultRights)];
            });
            this.updateAvailableRights();
        },
        updateAvailableRights() {
            if (!this.user.roles.length) {
                this.availableRights = this.allRights;
                return;
            } else {
                let userRoles = this.user.roles;
                if (typeof this.user.roles[0] == "object") {
                    userRoles = this.user.roles.map((role) => role.name);
                }

                this.availableRights = this.allRights.filter((right) => {
                    const flattenedRightRoles = right.roles.map(
                        (role) => role.name
                    );
                    return !flattenedRightRoles.filter(
                        (value) => -1 !== userRoles.indexOf(value)
                    ).length;
                });
            }
        },
    },
};
</script>
